export default "__VITE_ASSET__217820d4__"